<h2 mat-dialog-title>Add Action</h2>
<mat-dialog-content>

  <div class="container">
    <div class="row">
      <mat-form-field style="width: 100%;">
        <input [(ngModel)]="selectedDate" #txtDate matInput [matDatepicker]="dp" placeholder="Handled To" required>
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field style="width:100%; ">
        <mat-label>Comment</mat-label>
        <textarea [(ngModel)]="comment" style="height: 100px;" matInput required></textarea>
      </mat-form-field>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="{ comment: comment, date: selectedDate }" [disabled]="!comment">Add Action</button>
</mat-dialog-actions>
